import React, { PropsWithChildren } from 'react';
import { Skeleton, Text } from '@landr/maestro';

const Title: React.FC<PropsWithChildren<{ isLoading?: boolean }>> = ({
    children,
    isLoading,
}) => {
    if (isLoading) {
        return <Skeleton width="80%" height="20px" mt="xs" mb={'2xs'} />;
    }

    return (
        <Text
            textStyle="body-sm"
            fontWeight="bold"
            display="block"
            width="100%"
            overflow="hidden"
            textOverflow="ellipsis"
        >
            {children}
        </Text>
    );
};

Title.displayName = 'Card.Title';

export default Title;
